import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../config/config";
import Footer from "../../footer";
import Header from "../../Header/index";
import "./style.css";
import Video from "../../../assets/img/welcome.mp4";

const TendersShow = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [newsItems, setNewsItems] = useState([]);
  const { t, i18n } = useTranslation();

  const languageMap = {
    tj: 1,
    ru: 2,
    en: 3,
  };

  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    axios
      .get(`${API_BASE_URL}/api/events?lang=${langCode}&eventType=4`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((response) => {
        const filteredNews = response.data.enttities
          ?.filter((item) => item.type === 4)
          .slice(0, 6);
        setNewsItems(filteredNews || []);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [i18n.language]);

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    axios
      .get(`${API_BASE_URL}/api/events/${id}?lang=${langCode}`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((response) => {
        setNewsItem(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [id, i18n.language]);

  if (!newsItem) return <div>Loading...</div>;

  return (
    <>
      <div className="position-relative white-text" style={{ height: "200px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>
      <div
        className="container"
        style={{ marginTop: "50px", marginBottom: "30px" }}
      >
        <div className="row">
          <div
            className="col-md-9 mb-4 tenders-show-news-bloc p-3 rounded"
            style={{ height: "fit-content" }}
          >
            <div className="tenders-show-news-container">
              {newsItem.image && (
                <img
                  src={newsItem.image}
                  alt={newsItem.title}
                  className="img-fluid rounded mb-4"
                  style={{ width: "100%", height: "400px", objectFit: "cover" }}
                />
              )}
              <h1 className="tenders-show-title">{newsItem.title}</h1>
              <p className="tenders-show-date">
                {new Date(newsItem.createdDate).toLocaleDateString()}
              </p>
              {newsItem.shortDesc && (
                <p className="tenders-show-description">{newsItem.shortDesc}</p>
              )}
              {newsItem.longDesc && (
                <p className="tenders-show-description">{newsItem.longDesc}</p>
              )}
            </div>
          </div>
          <div className="col-md-3 px-4 mb-4">
            <h4 className="tenders-show-sidebar-title px-3 mb-3">
              {t("lastTenders")}
            </h4>
            {newsItems.map((item, index) => (
              <Link
                key={index}
                to={`/tenders/show/${item.id}`}
                className="tenders-show-card-link"
                style={{ textDecoration: "none" }}
              >
                <div className="card mb-3 shadow-sm border-0">
                  {item.image && (
                    <img
                      src={item.image}
                      alt="not found"
                      className="card-img-top"
                      style={{
                        height: "140px",
                        objectFit: "cover",
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                    />
                  )}
                  <div className="card-body">
                    <span
                      className="tenders-show-link"
                      style={{
                        color: "#333",
                        fontWeight: "500",
                      }}
                    >
                      {item.title?.length > 70
                        ? item.title.slice(0, 70) + "..."
                        : item.title}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
            <div className="text-end">
              <Link
                to={`/competitions`}
                className="btn tenders-show-view-all-btn w-100 mt-3"
              >
                {t("View All")}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TendersShow;
